import { render, staticRenderFns } from "./firma_canvas.vue?vue&type=template&id=71a9c132"
import script from "./firma_canvas.vue?vue&type=script&lang=js"
export * from "./firma_canvas.vue?vue&type=script&lang=js"
import style0 from "./firma_canvas.vue?vue&type=style&index=0&id=71a9c132&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports